import classNames from "classnames";
import React, { ReactNode } from "react";
import { TreeViewDivider } from "./treeview-divider";
import { TreeViewItem } from "./treeview-item";

type TreeViewProps = {
    className?: string;
    compact?: boolean;
    focus?: boolean;
    variant?: "" | "text" | "button" | "menu" | "treeview";
    lazyload?: boolean;
    children?: any;
    [x: string]: any;
};

export const TreeView = ({ className, variant, compact, focus, lazyload, children, ...props }: TreeViewProps) => {
    const cn = classNames("bd-treeview", className, {
        "bd-compact": compact,
        "bd-treeview-focus": focus,
    });

    const MapChildren = (children: React.ReactNode) => {
        if (typeof children === "function") return children;

        return React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return child;
            var x: any = child;
            if (x?.type === TreeViewDivider) return <li className="bd-treeview-divider"></li>;
            if (x?.type === TreeView || x?.type === TreeViewItem) {
                let newProps = { variant, compact, focus, lazyload, ...child.props, children: MapChildren(child.props?.children) };
                return React.cloneElement(child, newProps);
            }

            return !child.props?.children
                ? child
                : React.cloneElement(child, { lazyload, ...child.props, children: MapChildren(child.props.children) });
            return child;
        });
    };

    return (
        <ul className={cn} {...props}>
            {MapChildren(children)}
        </ul>
    );
};
